import { render, staticRenderFns } from "./tumbling.vue?vue&type=template&id=6724b934&scoped=true&"
import script from "./tumbling.vue?vue&type=script&lang=js&"
export * from "./tumbling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6724b934",
  null
  
)

export default component.exports